export class Constant{
    public static readonly  LOGGED_IN_USER:string = 'LOGGED_IN_USER';
    public static readonly  REFRESH_TOKEN:string = 'REFRESH_TOKEN';
    public static readonly USER_DATA:string = 'USER_DATA';
    public static readonly SESSION_TIMER:string = 'SESSION_TIMER'; 
    public static readonly ERROR_OCCURED:string = 'An error occured';
    public static readonly PASSWORD_RESET_SUCCESS:string = 'Password reset link sent to your email address. Please check your email and reset your password.';
    // pagination
    public static filterPageRegex: any = /[^0-9]/g;
  }
  